// extracted by mini-css-extract-plugin
export default {"search":"search_search__R2Qm3"};